import PropTypes from 'prop-types';
import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import LoadingButton from '../../components/LoadingButton';
import PageLayout from '../../components/PageLayout';
import SelectLoadingFetch from '../../components/SelectLoadingFetch';
import analytics from '../../lib/analytics';
import useCountries from '../../lib/hooks/useCountries';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';

const ResidenceCountryPage = ({ dispatchAddPageData, dispatchWizardNav }) => {
  const { selectedResidence: selected } = useCountries();
  const [selectedResidenceCountry, setSelectedResidenceCountry] = useState(selected);
  const [hasCountryChanged, setCountryChanged] = useState(false);

  const isInvalid = useMemo(
    () => selectedResidenceCountry === null || selectedResidenceCountry === undefined,
    [selectedResidenceCountry],
  );

  const handleSubmit = event => {
    event.preventDefault();

    if (isInvalid) {
      return;
    }

    analytics.sendEvent('Click - Next', 'residence-country');

    if (hasCountryChanged) {
      dispatchAddPageData(payloadFactory.createResetPageDataPayload('residenceState'));
    }

    const { value: residenceCountryCode } = selectedResidenceCountry;
    dispatchAddPageData(
      payloadFactory.createAddPageDataPayload(
        'residenceCountry',
        selectedResidenceCountry,
        'residenceCountry',
        residenceCountryCode,
      ),
    );

    dispatchWizardNav({ dir: 'fwd' });
  };

  const setCountry = data => {
    const countryChanged =
      typeof selected !== 'undefined' &&
      selected !== null &&
      data !== null &&
      selected.value !== data.value;
    setSelectedResidenceCountry(data);
    setCountryChanged(countryChanged);
  };

  return (
    <PageLayout title="Which country do you currently live in?">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col col--9/16-medium">
            <SelectLoadingFetch
              single="country"
              plural="countries"
              onChange={setCountry}
              selected={selectedResidenceCountry}
              hook={useCountries}
            />
          </div>
        </div>

        <div className="row-spacer">
          <LoadingButton type="submit" isDisabled={isInvalid}>
            Next
          </LoadingButton>
        </div>
      </form>
    </PageLayout>
  );
};

ResidenceCountryPage.propTypes = {
  dispatchAddPageData: PropTypes.func.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
};

export const mapDispatchToProps = {
  dispatchAddPageData: addPageData,
  dispatchWizardNav: navigateWizard,
};

export { ResidenceCountryPage };

export default connect(null, mapDispatchToProps)(ResidenceCountryPage);
